import React, { Component } from "react";
import { Button, Nav } from "react-bootstrap";
import { NavLink, HashRouter } from "react-router-dom";

class Info extends Component {
  onClickAppointment = () => this.props.history.push("/appointment");
  render() {
    const itemStyle = {
      height: "25px",
    };

    const linkStyle = {
      textDecoration: "underline",
      /*color: "#7c0070",*/
      color: "#424242",
    };

    return (
      <HashRouter>
        {/* <Button className="alignLeft">Test</Button> */}
        <svg
          style={itemStyle}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#424242"
          stroke-width="0.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-phone"
        >
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
        </svg>
        <div className="itemText">
          <a href="tel:+49421274710">0421 / 27 47 10</a>
        </div>
        <svg
          style={itemStyle}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#424242"
          stroke-width="0.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-mail"
        >
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
          <polyline points="22,6 12,13 2,6"></polyline>
        </svg>
        {/* <div> */}
        <Nav.Link>
          <NavLink style={linkStyle} to="/appointment">
            Jetzt Termin vereinbaren
          </NavLink>
        </Nav.Link>
        {/* </div> */}
      </HashRouter>
    );
  }
}

export default Info;
